export const  baseUrl=  {
    // baseUrl:"http://localhost:1000",
    baseUrl:"https://plenitude-ministry-main-api-service.vercel.app",
    token:`Sb5xnq9Gwe4mIlyucQJpi0lCoyn+faar5SRVzAFGDAqZbr6kRROW/`,
    tokenType:"Bearer",
}